import en from "./translations.en";

const messages = {
  en,
};

export default messages;
